import { getStoreCategoryList } from '@/api/seller.js'


const state = {
  list:[],//参展商分类列表
}

const mutations = {
  setStoreCategoryList: (state, n) => {
    state.list = n;
  }
}

const actions = {
  getStoreCategoryList({ commit }){
    return new Promise((resolve, reject) => {
      getStoreCategoryList().then(res=>{
        commit('setStoreCategoryList',res)
        console.log(res);
        resolve(res);
      });
    }) 
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

